import React from "react";
import { SurveySegment } from "../../../../amorg-common";
import { Chip } from "../../../../designSystem/Chip";
import { Flex } from "../../../../designSystem/compositeComponents/FlexHelpers";

type SegmentListChipListProps = {
    identifier: string,
    segments: SurveySegment[]
};
export function SegmentListChipList (props: SegmentListChipListProps): JSX.Element
{
    return (
        <Flex gap={4} style={{ flexWrap: 'wrap' }}>
            {props.segments.map((s, index) =>
                <Chip key={props.identifier + '-' + index} selected>
                    {s.value}
                </Chip>
            )}
        </Flex>
    );
}